import {Component, Input, OnInit, Output} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import {environment} from "@environment";
import {Country, EventItem, EventItemType, Lookups} from "@model";
import {AuthenticationService, EventService, PublicEventsService, TOAST_STATE, ToastService} from "@services";
import {AbstractComponent} from "../abstract.component";
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-event-grid-item-with-image-small',
  templateUrl: './event-grid-item-with-image-small.component.html',
  styleUrls: ['./event-grid-item-with-image-small.component.scss'],
  providers: [DatePipe]
})
export class EventGridItemWithImageSmall extends AbstractComponent implements OnInit {
  @Input() eventItem?: EventItem;
  @Input() eventItemType?: EventItemType;
  @Input() additionalClass?: string;
  @Input() isLanding = false;
  @Input() isFinishedEvent = false;
  @Input() countries: Lookups[] = [];
  @Input() isOnWishList = false;
  @Input({required: true}) languages: Lookups[] = [];
  @Output() favoriteItems: EventItem[] = [];

  eventCountry?: Country;

  constructor(
    public translocoService: TranslocoService,
    private authenticationService: AuthenticationService,
    private datePipe: DatePipe,
    private eventService: EventService,
    private publicEventsService: PublicEventsService,
    private toastService: ToastService
  ) {
    super();
  }

  ngOnInit(): void {
    this.setEventCountry();
  }

  setEventCountry(): void {
    if (this.countries.length && this.eventItem?.country) {
      this.eventCountry = this.countries.find(item => item.id === this.eventItem?.country);
    }
  }

  validCityAndCountry(country?: string, city?: string): string {
    return [city, country].filter(Boolean).join(', ');
  }

  addToFavoritesButtonClicked(event: MouseEvent, eventItem?: EventItem): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.authenticationService.isAuthenticated()) {
      this.addToFavoritesAction(eventItem);
    } else {
      this.toastService.showToast(TOAST_STATE.warning, this.translocoService.translate("event.favorite.save.warning"));
    }
  }

  addToFavoritesAction(eventItem?: EventItem): void {
    if (eventItem?.id) {
      const action = eventItem.favorite
        ? this.publicEventsService.removeEventFromFavorites(eventItem!.id!)
        : this.publicEventsService.addEventToFavorites(eventItem!.id!);

      action.subscribe(actionResult => {
        if (actionResult.result) {
          this.toastService.showToast(TOAST_STATE.success, this.translocoService.translate(
            eventItem.favorite ? "event.favorite.delete.success" : "event.favorite.save.success"
          ));
          eventItem.favorite = !eventItem.favorite;
          this.publicEventsService.fetchUserFavoritesEvent().subscribe(favorites => {
            this.favoriteItems = favorites;
          });
        }
      });
    }
  }

  formatDate(date: Date | string): string {
    return this.datePipe.transform(date, 'MMM')?.slice(0, 3) ?? '';
  }

  protected readonly environment = environment;
}
